import { FC } from "react";
import { useGetCreditOtions } from "../ServerSideStates";
import { Col, Divider, Row, Typography } from "antd";
import PriceFormatter from "apps/Common/PriceFormatter";

const CreditList: FC<{
  data: { creditAmount: number; termMonths: number };
}> = ({ data }) => {
  const creditOptions = useGetCreditOtions(data);
  const { Text } = Typography;

  return (
    <>
      {creditOptions?.data?.data?.length > 0 ? (
        <>
          <Col xs={24}>
            <Row gutter={[0, 20]}>
              {creditOptions?.data?.data.map((item: any) => {
                return (
                  <>
                    <Col xs={24} className="!bg-[#f5f6fb] !p-4">
                      <Row
                        gutter={[
                          { xs: 0, md: 0 },
                          { xs: 0, md: 20 },
                        ]}
                      >
                        <Col xs={24} className="!hidden md:!block">
                          <Row>
                            <Col xs={24}>
                              <Row>
                                <Col xs={24} md={6}>
                                  <Text className="!font-bold !text-[#6E7583]">
                                    Banka
                                  </Text>
                                </Col>
                                <Col xs={24} md={6}>
                                  <Text className="!font-bold !text-[#6E7583]">
                                    Aylık Taksit Tutarı
                                  </Text>
                                </Col>
                                <Col xs={24} md={6}>
                                  <Text className="!font-bold !text-[#6E7583]">
                                    Faiz Oranı
                                  </Text>
                                </Col>
                                <Col xs={24} md={6}>
                                  <Text className="!font-bold !text-[#6E7583]">
                                    Toplam Ödeme
                                  </Text>
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                        </Col>

                        <Col xs={24}>
                          <Divider className="!m-0 !hidden md:!block" />
                        </Col>

                        <Col xs={24}>
                          <Row>
                            <Col xs={24}>
                              <Row
                                gutter={[
                                  { xs: 0, md: 0 },
                                  { xs: 10, md: 0 },
                                ]}
                              >
                                <Col xs={24} md={6} >
                                  <Row>
                                    <Col xs={24} className="!block md:!hidden">
                                      <Text className="!font-bold !text-[#6E7583]">
                                        Banka
                                      </Text>
                                    </Col>
                                    <Col xs={24}>
                                      <Text className="!text-black !text-sm  md:!text-lg xxl:!text-xl">
                                        {item.bankName}
                                      </Text>
                                    </Col>
                                  </Row>
                                </Col>
                                <Col xs={24} md={6}>
                                  <Row>
                                    <Col xs={24} className="!block md:!hidden">
                                      <Text className="!font-bold !text-[#6E7583]">
                                        Aylık Taksit Tutarı
                                      </Text>
                                    </Col>
                                    <Col xs={24}>
                                      <Text>
                                        <PriceFormatter
                                          inputPrice={item?.monthlyInstallment}
                                        />
                                      </Text>
                                    </Col>
                                  </Row>
                                </Col>
                                <Col xs={24} md={6}>
                                  <Row>
                                    <Col xs={24} className="!block md:!hidden">
                                      <Text className="!font-bold !text-[#6E7583]">
                                        Faiz Oranı
                                      </Text>
                                    </Col>
                                    <Col xs={24}>
                                      <Text>{item?.interestRate + " %"}</Text>
                                    </Col>
                                  </Row>
                                </Col>
                                <Col xs={24} md={6}>
                                <Row>
                                    <Col xs={24} className="!block md:!hidden">
                                      <Text className="!font-bold !text-[#6E7583]">
                                      Toplam Ödeme
                                      </Text>
                                    </Col>
                                    <Col xs={24}>
                                    <PriceFormatter
                                    inputPrice={item?.totalPayment}
                                  />
                                    </Col>
                                  </Row>
                                  
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </Col>
                  </>
                );
              })}
            </Row>
          </Col>
        </>
      ) : (
        <></>
      )}
    </>
  );
};

export default CreditList;
